import { useMemo, useState } from 'react';
import { StyleEditorContext } from './StyleEditorContext';
import { StyleEditorDrawer } from './StyleEditorDrawer';

type Props = {
  children: React.ReactNode;
};

export const StyleEditorProvider = ({ children }: Props) => {
  const [openedPath, setOpenedPath] = useState<string | null>(null);
  const [hoveredPath, setHoveredPath] = useState<string | null>(null);

  const value = useMemo(
    () => ({
      openDrawer: (path: string) => setOpenedPath(path),
      closeDrawer: () => setOpenedPath(null),
      openedPath,
      isOpen: !!openedPath,
      hoveredPath,
      setHoveredPath,
    }),
    [openedPath, hoveredPath],
  );

  return (
    <StyleEditorContext.Provider value={value}>
      {children}
      <StyleEditorDrawer />
    </StyleEditorContext.Provider>
  );
};
